import { useAtomValue } from 'jotai';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { getRequest as requestFormGetActiveRequest } from 'pages/requestForm/selectors/pageSelectors';
import { FC, memo } from 'react';
import { ContentSplitViewMode, contentSplitViewState } from 'shared/states';

import { getActiveRequestSafe as requestListGetActiveRequest } from '../../selectors/pageSelectors';
import { NetSuiteBillLinkedToBillPaymentRequestCardWrapper } from '../netsuite/NetSuiteBillLinkedToBillPaymentRequestCardWrapper/NetSuiteBillLinkedToBillPaymentRequestCardWrapper';
import { XeroBillLinkedToBatchPaymentRequestCardWrapper } from '../xero/XeroBillLinkedToBatchPaymentRequestCardWrapper/XeroBillLinkedToBatchPaymentRequestCardWrapper';
import { SplitViewRequestCardWrapperProps } from './SplitViewRequestCardWrapper.types';

export const SplitViewRequestCardWrapper: FC<SplitViewRequestCardWrapperProps> = memo((props) => {
    const { setContainerTitle } = props;

    const contentSplitView = useAtomValue(contentSplitViewState);
    const activePageId = useSelector(selectors.navigation.getActivePageId);

    const getActiveRequest = activePageId === 'requestForm' ? requestFormGetActiveRequest : requestListGetActiveRequest;

    const activeRequest = useSelector(getActiveRequest);

    const activeRequestIsBatchPayment =
        activeRequest?.integrationCode === domain.IntegrationCode.XeroAmaxPayBatchPayment ||
        activeRequest?.integrationCode === domain.IntegrationCode.XeroAirwallexBatchPayment ||
        activeRequest?.integrationCode === domain.IntegrationCode.XeroBillBatchPayment;

    if (contentSplitView.mode === ContentSplitViewMode.BillLinkedToBatchPayment && activeRequestIsBatchPayment) {
        return (
            <XeroBillLinkedToBatchPaymentRequestCardWrapper
                setContainerTitle={setContainerTitle}
                batchPaymentRequest={activeRequest}
            />
        );
    }

    const activeRequestIsNetSuiteBillPayment =
        activeRequest?.integrationCode === domain.IntegrationCode.NetSuiteBillPayment;

    if (
        contentSplitView.mode === ContentSplitViewMode.NetSuiteBillLinkedToBillPayment &&
        activeRequestIsNetSuiteBillPayment
    ) {
        return (
            <NetSuiteBillLinkedToBillPaymentRequestCardWrapper
                setContainerTitle={setContainerTitle}
                billPaymentRequest={activeRequest}
            />
        );
    }

    return null;
});

SplitViewRequestCardWrapper.displayName = 'SplitViewRequestCardWrapper';
